import { format } from "date-fns";
import { StyledPlanillas } from "../../styled/Planillas";

const FechaPresentacionLabel = ({ date }) => {

  return (
    <StyledPlanillas.FechaPresentacionContainer variant="h6">
      Fecha de Presentación: {format(date ? date : new Date(), "dd/MM/yyyy")}
    </StyledPlanillas.FechaPresentacionContainer>
  );
};

export default FechaPresentacionLabel;
